module.exports = __webpack_public_path__ + "img/transfers.70c0d70a.png";